// import type { PlayerInterruptEvent } from '../types'
import { PlayerLayout } from '../types'

import { isPlayerOpen } from './helpers'
import type { IPlayerGlobalStateSlice } from './slice'
import { PLAYER_SLICE_KEY } from './slice'
import type { PlayerGlobalState } from './types'

/**
 * @returns player model actions
 */
export function playerActionsSelector(
  state: IPlayerGlobalStateSlice,
): Partial<PlayerGlobalState['actions']> {
  if (!state[PLAYER_SLICE_KEY]) {
    return {}
  }
  return state[PLAYER_SLICE_KEY]?.actions || {} // (CS-3310) For some unknown reason, the slice might be undefined. It does not happen to other slices though :man-shrugging:
}

/**
 * @returns Whether there is opened player and whether is in fullscreen mode.
 */
export function hasFullscreenPlayerLayoutSelector(
  state: IPlayerGlobalStateSlice,
): boolean {
  return playerStateOpenedSelector(state)?.layout === PlayerLayout.FULLSCREEN
}

/**
 * Get player state by widget id
 * @param widgetId
 * @returns
 */
export function playerStateByWidgetIdSelector(widgetId: string | undefined) {
  return (state: IPlayerGlobalStateSlice) =>
    widgetId ? state[PLAYER_SLICE_KEY]?.playerStates?.[widgetId] : undefined
}

/**
 * Get player state of currently opened player. There can be only one player which is
 * fullscreen/minimized at a time.
 * @param state
 * @returns
 */
export function playerStateOpenedSelector(state: IPlayerGlobalStateSlice) {
  const playerStates = state[PLAYER_SLICE_KEY]?.playerStates
  return playerStates
    ? Object.values(playerStates).find(isPlayerOpen)
    : undefined
}

/**
 * Get video state by video id
 * @param videoId
 * @returns
 */
export function videoStateByVideoIdSelector(videoId: string | undefined) {
  return (state: IPlayerGlobalStateSlice) =>
    videoId ? state[PLAYER_SLICE_KEY]?.videoStates?.[videoId] : undefined
}

/**
 *
 */
export function isLivestreamJoinEventTrackedSelector(videoId?: string) {
  return (state: IPlayerGlobalStateSlice): boolean =>
    videoId
      ? Boolean(
          state[PLAYER_SLICE_KEY]?.isLivestreamJoinEventTrackedByVideoId?.[
            videoId
          ],
        )
      : false
}

/**
 * @returns Whether user interacted with mute and what was the result.
 */
export function isUserMutedSelector(state: IPlayerGlobalStateSlice) {
  return state[PLAYER_SLICE_KEY]?.isUserMuted
}
